import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Triangle({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // depth 0 = flat, depth 100 = peak at top (y=0)
  const peakY = 120 - (depth / 100) * 120;
  // position 0 = left, 50 = center, 100 = right
  const peakX = 200 + (position / 100) * 800;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <polygon points={ `0,120 ${peakX},${peakY} 1200,120` } fill={ fill } mask={ mask } />
    </svg>
  );
}

Triangle.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
